module.exports = __webpack_public_path__ + "static/media/debateImage.455a8ac8.jpg";